import { TipoNaturezaUsuario } from "./tipo-natureza-usuario.model";

export class UsuarioSistema {
  id: number;
  nome: string;
  nomeCompleto: string;
  cpf: string;
  cnpj: string;
  tipoNaturezaUsuario: TipoNaturezaUsuario
}
